<template>
	<a
		v-if="buttonUrl.startsWith('https://')"
		:href="buttonUrl"
		class="my-2 inline-block rounded bg-(--bg-color) font-prenton-cond leading-4 tracking-4xl text-(--font-color) no-underline transition-colors duration-150 outline-hidden hover:bg-(--hover-bg-color) focus:bg-(--hover-bg-color) active:bg-(--hover-bg-color)"
		:class="sizeClasses"
		:style="linkStyles"
	>
		{{ blok.title }}
	</a>

	<nuxt-link
		v-else
		:to="buttonUrl"
		class="my-2 inline-block rounded bg-(--bg-color) font-prenton-cond leading-4 tracking-4xl text-(--font-color) no-underline transition-colors duration-150 outline-hidden hover:bg-(--hover-bg-color) focus:bg-(--hover-bg-color) active:bg-(--hover-bg-color)"
		:class="sizeClasses"
		:style="linkStyles"
	>
		{{ blok.title }}
	</nuxt-link>
</template>

<script setup lang="ts">
import type {ContentButton} from "@pkg/shared/types";

import {useModifyColor} from "@pkg/shared/composables/use-modify-color";
import formatSbUrl from "@pkg/shared/utils/format-sb-url";

const props = defineProps<{
	blok: ContentButton;
}>();

// Note that this isn't reactive - there should be no need, plus this is lazily copy-pasted from old code

const buttonSize = (props.blok.size as "sm" | "md" | "lg") || "md";
const fontColor = props.blok.font_color?.color ?? "#ffffff";
const backgroundColor = props.blok.background_color?.color ?? "#000000";
const darkerBackgroundColor = useModifyColor(backgroundColor, 50);

const sizeClasses = {
	sm: "text-sm leading-4 tracking-4xl p-xs",
	md: "uppercase text-md leading-none tracking-5xl p-sm whitespace-nowrap",
	lg: "uppercase text-lg leading-none tracking-6xl p-md whitespace-nowrap",
}[buttonSize];

const linkStyles = `
    --font-color: ${fontColor};
    --bg-color: ${backgroundColor};
    --hover-bg-color: ${darkerBackgroundColor};`;

const buttonUrl = formatSbUrl(props.blok.link);
</script>

<style scoped></style>
